import React from 'react';
import DOMPurify from 'dompurify';
import '../CSS/EmbeddedAudio.css';

const EmbeddedAudio: React.FC<{ element: any }> = ({ element }) => {
  const brightcoveAccountId = element.brightcove_account_id?.value;
  const brightcovePlayerId = element.brightcove_player_id?.value;
  const brightcoveAudioId = element.brightcove_audio_id?.value;

  // Construct the audio-only source URL
  const audioSrc = `https://players.brightcove.net/${brightcoveAccountId}/${brightcovePlayerId}_default/index.html?videoId=${brightcoveAudioId}&showTitle=false`;

  // Utility function to check if rich text contains meaningful content
  const hasMeaningfulText = (richText: any): boolean => {
    if (!richText?.value) return false; // Check if value exists
    const strippedText = DOMPurify.sanitize(richText.value, {
      ALLOWED_TAGS: [],
      ALLOWED_ATTR: [],
    }).trim(); // Remove all HTML tags and trim whitespace
    return /^[\w\s]+$/.test(strippedText); // Return true if content has alphanumeric or whitespace characters only
  };

  // Fallback for alt text
  const altText = element.description___alt_text?.value || 'Audio content';

  return (
    <div>
      {/* <div style={{ textAlign: 'center' }}> {element.title?.value} </div> */}
      <div className="embedded-audio">
        <iframe
          src={audioSrc}
          title={altText}
          aria-label={altText} // Add aria-label for better accessibility
          allow="autoplay; encrypted-media"
          allowFullScreen
        >
          Your browser does not support iframes.
        </iframe>
        <div
          className="da-footer"
          style={{ marginTop: '0', paddingLeft: '0px' }}
        >
          <span className="daid" style={{ textAlign: 'left' }}>
            {hasMeaningfulText(element.permission_language) &&
              DOMPurify.sanitize(element.permission_language?.value, {
                ALLOWED_TAGS: [],
                ALLOWED_ATTR: [],
              }).trim()}
            {element.digital_asset_id?.value &&
              ` [${element.digital_asset_id?.value}]`}
          </span>
        </div>
      </div>
    </div>
  );
};

export default EmbeddedAudio;
